const Art = 0b1000000
const Extra = 0b0100000
const Foreign = 0b0010000
const ElecA = 0b0001000
const ElecB = 0b0000100
const ElecC = 0b0000010
const ElecD = 0b0000001
const Elec = [ElecA, ElecB, ElecC, ElecD]

export { Art, Extra, Foreign, ElecA, ElecB, ElecC, ElecD, Elec }